import { Text } from '@montel/montelpro-shared-components-v2';
import CreateCompanyForm, {
	CreateCompanyFormState,
} from 'components/companies/CreateCompanyForm';
import { Company } from 'domain/company/Company';
import { styled } from 'styled-components';

const CreateCompanyCTA = styled(Text)`
	cursor: pointer;
	color: ${({ theme }) => theme.colors.iconBrand};
	&:hover {
		color: ${({ theme }) => theme.colors.iconBrandStatic};
	}
`;

export const CreateCompanySection: React.FC<{
	showCreateCompanySection: boolean;
	setShowCreateCompanySection: (show: boolean) => void;
	onCreateCompanyClicked: () => void;
	initialFormState: CreateCompanyFormState;
	onCompanyCreated: (company: Company) => void;
}> = ({
	showCreateCompanySection,
	setShowCreateCompanySection,
	onCreateCompanyClicked,
	initialFormState,
	onCompanyCreated,
}) => (
	<>
		{showCreateCompanySection ? (
			<Text size="sm">Create a new company</Text>
		) : (
			<>
				<Text size="sm">
					If no suitable company is listed, you can{' '}
					<CreateCompanyCTA
						as="span"
						size="sm"
						text="create a new one"
						color="iconBrand"
						onClick={onCreateCompanyClicked}
					>
						create a new one
					</CreateCompanyCTA>
					.
				</Text>
			</>
		)}
		{showCreateCompanySection && (
			<CreateCompanyForm
				initialFormState={initialFormState}
				onSuccess={onCompanyCreated}
				onCancel={() => {
					setShowCreateCompanySection(false);
				}}
			/>
		)}
	</>
);
